/* eslint-disable prefer-destructuring */
/* eslint-disable max-classes-per-file */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* wg. Floating Labels von PrimeReact */

/*
Item: Form to release objects for different groups
Name: ReleaseObjects
Format: Frontend component, partial screen
*/

import React from 'react';
import { Growl } from 'primereact/growl';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { TabView, TabPanel } from 'primereact/tabview';
import JsonHelper, { TableSavedNames } from '../utils/statisticsUtils';
import MessageService from '../service/MessageService';
// import { returnUserRights } from '../utils/roleUtils';
import NodeService from '../service/NodeService';
import rightsTemplate from '../service/data/TemplateRightsUpdate.json';
import PanelView from '../components/PanelView';
import ReleaseObjectsDialog from '../components/dialogue/ReleaseObjectsDialog';

const DialogType = Object.freeze({
  none: 0,
  releaseToAll: 1,
  releaseGroup: 2,
  releaseToOffice: 3,
  releaseConfirmation: 4,
});

const rowsPerPage = 30;

export default class ReleaseObjects extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lastRightUsed: undefined,
      returnAgain: undefined,
      activeIndex: 0,
      currentDialogType: DialogType.none,
      visibleWait: true,
      currentNode: undefined,
      // newNodeDataName: undefined,
      allNodes: [],
      // state for search bar
      searchCriterion: { name: 'Name', value: 'Fachschlüssel' },
      searchText: '',
      // state for sorting
      sortCriterion: 'Name',
      sortDirection: 'ASC',
      sortingSelection: {
        Name: 'ASC',
        Beschreibung: '',
        Klassifikationsschlüssel: '',
      },
      // all users Data to show the table
      userData: [null, null, null],
      entryProperties: [
        {
          name: '',
          longtext: '',
          statisticName: '',
        },
        {
          name: '',
          longtext: '',
          statisticName: '',
        },
        {
          name: '',
          longtext: '',
          statisticName: '',
        },
      ],
    };
    this.messageService = new MessageService();
    this.nodeservice = new NodeService();
    this.confirmDialog = this.confirmDialog.bind(this);
    this.rejectDialog = this.rejectDialog.bind(this);
    this.onHide = this.onHide.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleVisibility = this.handleVisibility.bind(this);
    this.handleUserData = this.handleUserData.bind(this);
    this.myTreeTable = React.createRef();
    this.onPage = this.onPage.bind(this)
  }

  componentDidMount = async () => {
    this.openDialog();
    let entries;
    const userData = [];
    const type = 'right';
    const objectTyp = 'RIGHT';
    const objectNumber = '090'; // RGIHT=090
    // Wertmerkmale
    let typeString = 'Wertmerkmal';
    let right = 'BENGRP';
    entries = await this.getDirectory(type, right, objectNumber, objectTyp, typeString);
    userData[0] = entries;
    try {
      // move here
    } catch (err) {
      console.log('ERROR in componentDidMount', err);
    } finally {
      this.setState({
        userData,
        visibleWait: false,
      });
    }
  }

  handleValueChange(node, type) {
    const newState = { currentDialogType: type, currentNode: node };
    this.setState(
      newState,
    );
  }

  handleVisibility(visibleWait) {
    this.setState({ visibleWait });
  }

  handleUserData(index, value) {
    const { userData } = this.state;
    userData[index] = value;
    this.setState({ userData });
  }

  async handleTabChange(e) {
    if (e.index !== this.state.activeIndex) {
        this.setState({ activeIndex: e.index });
        await this.reloadTab(e.index);
    }
  }

  onHide() {
    this.setState({
      currentDialogType: DialogType.none,
      currentNode: undefined,
      lastRightUsed: undefined,
      returnAgain: undefined,
    });
  }

  async getDirectory(type, right, objectNumber, objectTyp, typeString, page=1, maxRowsPerPage=10, selection) {
    const elementsData = await this.messageService.postVariableDirectory(
      'directory', type, right, objectNumber, objectTyp, typeString, undefined, undefined, rowsPerPage, selection, page, maxRowsPerPage);
    if (elementsData[0]) { // 1800
      this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
      this.setState({
        visibleWait: false,
        totalRecords: 0,
      });
      return [];
    } else {
      const entries = elementsData.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
      const totalRecords = elementsData.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.potentialSelectionEntrySize;
      this.setState({ totalRecords });
      return entries;
    }
  }

  indexToTypeString(index) {
    return index < 2 ? 'Wertmerkmal' :
      index < 4 ? 'Abruftabelle' :
        index < 6 ? 'Regel' :
          'Klassifizierendes Merkmal';
  }

  async reloadTab(index) {
    const { userData, activeIndex } = this.state;
    if (index === undefined) index = activeIndex;
    this.setState({ visibleWait: true });
    const type = 'right';
    const objectTyp = 'RIGHT';
    const objectNumber = '090';
    // Wertmerkmale
    const typeString = this.indexToTypeString(index);
    const right = index % 2 === 0 ? 'BENGRP' : 'GRP';
    const entries = await this.getDirectory(type, right, objectNumber, objectTyp, typeString);
    userData[index] = entries;
    this.setState({
      userData,
      visibleWait: false,
    });
  }

  async onPage(first, rows, selection) {
    const page = (first + rows) / rows;
    const { userData } = this.state;
    let { activeIndex } = this.state;
    this.setState({ visibleWait: true });
    const type = 'right';
    const objectTyp = 'RIGHT';
    const objectNumber = '090';
    // Wertmerkmale
    const typeString = this.indexToTypeString(activeIndex);
    const right = activeIndex % 2 === 0 ? 'BENGRP' : 'GRP';
    const entries = await this.getDirectory(type, right, objectNumber, objectTyp, typeString,page, rows, selection );
    userData[activeIndex] = entries;
    this.setState({
      userData,
      visibleWait: false,
    });
  }

  openDialog(node, type) {
    const newState = { currentDialogType: type, currentNode: node };
    this.setState(newState);
  }

  async rejectDialog() {
    const {
      currentNode, allNodes,
      lastRightUsed,
    } = this.state;
    let obj = {};
    obj = await this.releaseGroup(currentNode, lastRightUsed, true);
    const { success, noDialog } = obj;
    if (success) this.reloadTab();
    if (noDialog) this.setState({ allNodes }, () => this.onHide());
  }

  async confirmDialog() {
    const {
      currentNode, allNodes, currentDialogType,
      lastRightUsed,
    } = this.state;
    let obj = {};
    switch (currentDialogType) {
      case DialogType.releaseToAll:
        obj = await this.releaseGroup(currentNode, 'FREE');
        break;
      case DialogType.releaseGroup:
        obj = await this.releaseGroup(currentNode, 'GRP');
        break;
      case DialogType.releaseToOffice:
        obj = await this.releaseGroup(currentNode, 'OFFICE');
        break;
      case DialogType.releaseConfirmation:
        obj = await this.releaseGroup(currentNode, lastRightUsed, false);
        break;
      default:
    }
    const { success, noDialog } = obj;
    if (success) this.reloadTab();
    if (noDialog) this.setState({ allNodes }, () => this.onHide());
  }

  async releaseGroup(currentNode, rightArea, isReject) {
    let { returnAgain } = this.state;
    let obj = {
      success: true,
      noDialog: true,
    };
    let { success, noDialog } = obj;
    const node = currentNode;
    const { id, entry } = node;
    const objectNumber = '090';
    const type = 'right';
    let sendMessage = JSON.stringify(rightsTemplate);
    sendMessage = sendMessage.replace(/\$SESSIONID/, sessionStorage.getItem('uuid'));
    sendMessage = JSON.parse(sendMessage);
    const insertMessage = JsonHelper.deepCopy(entry);
    insertMessage.rightObject.ownerInfo.rightArea = rightArea;
    sendMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel = insertMessage;
    if (returnAgain) {
      if (isReject) { // alle Merkmalsausprägungen freigegeben:
        returnAgain.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].optionArray = [returnAgain.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].optionArray.find((option) => option.key === "n")]; // für nein
      } else {
        returnAgain.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].optionArray = [returnAgain.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].optionArray.find((option) => option.key === "y")]; // für ja
      }
      sendMessage = returnAgain.data
    };
    const elementsData = await this.messageService.postRecordStructureProperties(
      id, objectNumber, type, false, undefined, sendMessage, 'updateremoveowner',
    );
    if (elementsData[0]) {
      let message = elementsData[0].replace('java.lang.Exception:', '');
      if (message === 'Sollen mit der Freigabe des Objekts auch\n  Merkmal freigegeben werden?') { // errNum 5000
        message = 'Bitte geben Sie vor der Regel das Merkmal frei.';
      } else if (message === 'Sollen mit der Freigabe des Objekts auch\n  Merkmalsausprägung freigegeben werden?') {
         noDialog = false; // Folgedialog
        // elementsData[2] enthlät die Anwort, die geändert und erneut gesendet wird
        returnAgain = elementsData[2]; // zum erneuten senden
        returnAgain.data.contents[
          'genesis.container.content.GenesisTMContent'
        ].menuRoot = null;
        returnAgain.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].stackTrace = [];
        returnAgain.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].handling = 'ACKNOWLEDGMENT'; // acknowledgement
        console.log('DATA#returnAgain', returnAgain);
        this.setState({ lastRightUsed: rightArea, returnAgain }); 
        this.handleValueChange(node, DialogType.releaseConfirmation);
      }
      this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: message });
      success = false;
    }
    obj = { success, noDialog };
    return obj;
  }

  // eslint-disable-next-line class-methods-use-this
  typeTemplate(node) {
    return (
      node.data.typ === 'DEFAULT' ? (
        <span>
          {node.data.name}
          <i title="Standardtabelle" className="pi pi-md-local-offer" />
        </span>
      ) : node.data.name
    );
  }

  makeHeaderCell(criterionName, text, sortable) {
    const { sortingSelection, sortCriterion } = this.state;
    const lookup = sortingSelection[criterionName];
    let retColor;
    let retClass;
    if (criterionName !== sortCriterion) {
      retClass = 'p-sortable-column-icon pi pi-fw pi-sort';
      retColor = 'grey';
    } else {
      retColor = 'black';
      if (lookup === 'ASC') {
        retClass = 'p-sortable-column-icon pi pi-fw pi-sort-up';
      } else {
        retClass = 'p-sortable-column-icon pi pi-fw pi-sort-down';
      }
    }
    const sortingClass = retClass;
    let ret = (
      <th style={{ cursor: 'pointer', color: retColor }} onClick={() => this.selectSorting(criterionName)}>
        {text}
        <span className={sortingClass} />
      </th>
    );
    if (!sortable) {
      ret = (
        <th style={{ color: retColor }}>
          {text}
          <span />
        </th>
      );
    }
    return ret;
  }

  render() {
      const { totalRecords } = this.state
    const role = sessionStorage.getItem('role');
    if (role === 'INTERNAL_USER') {
      window.location.replace('./');
    }
    const statistic = 'admin';
    const {
      visibleWait, currentDialogType, allNodes, currentNode,
    } = this.state;
    const {
      activeIndex, userData, // searchCriterion, searchText, entryProperties,
    } = this.state;
    return (
      <div className="p-col-12 p-lg-12">
        <Growl ref={(el) => { this.growl = el; }} />
        <Dialog
          header="Lade Daten..."
          closable={false}
          closeOnEscape={false}
          visible={visibleWait}
          modal
          onHide={() => this.setState({ visibleWait: false })}
        >
          <div style={{ textAlign: 'center' }}><ProgressSpinner /></div>
        </Dialog>
        <div className="p-grid dashboard">
          <div id="evaluation" className="p-col-12 p-md-12">
            <h2>{TableSavedNames[statistic][0]}</h2>
          </div>

          <div id="evaluation" className="p-col-12 p-md-12">
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => this.handleTabChange(e)}
            >
              <TabPanel
                header="Wertmerkmale (Benutzer)"
              >
                <PanelView
                  typeString="Wertmerkmal"
                  userData={userData[activeIndex]}
                  index={activeIndex}
                  openDialog={this.openDialog}
                  onValueChange={this.handleValueChange}
                  onVisibility={this.handleVisibility}
                  onUserData={this.handleUserData}
                  onPage={this.onPage}
                  totalRecords={totalRecords}
                />
              </TabPanel>
              <TabPanel
                header="Wertmerkmale (Gruppen)"
              >
                <PanelView
                  typeString="Wertmerkmal"
                  userData={userData[activeIndex]}
                  index={activeIndex}
                  openDialog={this.openDialog}
                  onValueChange={this.handleValueChange}
                  onVisibility={this.handleVisibility}
                  onUserData={this.handleUserData}
                  onPage={this.onPage}
                  totalRecords={totalRecords}
                />
              </TabPanel>
              <TabPanel
                header="Tabellen (Benutzer)"
              >
                <PanelView
                  typeString="Abruftabelle"
                  userData={userData[activeIndex]}
                  index={activeIndex}
                  openDialog={this.openDialog}
                  onValueChange={this.handleValueChange}
                  onVisibility={this.handleVisibility}
                  onUserData={this.handleUserData}
                  onPage={this.onPage}
                  totalRecords={totalRecords}
                />
              </TabPanel>
              <TabPanel
                header="Tabellen (Gruppen)"
              >
                <PanelView
                  typeString="Abruftabelle"
                  userData={userData[activeIndex]}
                  index={activeIndex}
                  openDialog={this.openDialog}
                  onValueChange={this.handleValueChange}
                  onVisibility={this.handleVisibility}
                  onUserData={this.handleUserData}
                  onPage={this.onPage}
                  totalRecords={totalRecords}
                />
              </TabPanel>
              <TabPanel
                header="Regeln (Benutzer)"
              >
                <PanelView
                  typeString="Regel"
                  userData={userData[activeIndex]}
                  index={activeIndex}
                  openDialog={this.openDialog}
                  onValueChange={this.handleValueChange}
                  onVisibility={this.handleVisibility}
                  onUserData={this.handleUserData}
                  onPage={this.onPage}
                  totalRecords={totalRecords}
                />
              </TabPanel>
              <TabPanel
                header="Regeln (Gruppen)"
              >
                <PanelView
                  typeString="Regel"
                  userData={userData[activeIndex]}
                  index={activeIndex}
                  openDialog={this.openDialog}
                  onValueChange={this.handleValueChange}
                  onVisibility={this.handleVisibility}
                  onUserData={this.handleUserData}
                  onPage={this.onPage}
                  totalRecords={totalRecords}
                />
              </TabPanel>
              <TabPanel
                header="Kl. Merkmale (Benutzer)"
              >
                <PanelView
                  typeString="Klassifizierendes Merkmal"
                  userData={userData[activeIndex]}
                  index={activeIndex}
                  openDialog={this.openDialog}
                  onValueChange={this.handleValueChange}
                  onVisibility={this.handleVisibility}
                  onUserData={this.handleUserData}
                  onPage={this.onPage}
                  totalRecords={totalRecords}
                />
              </TabPanel>
              <TabPanel
                header="Kl. Merkmale (Gruppen)"
              >
                <PanelView
                  typeString="Klassifizierendes Merkmal"
                  userData={userData[activeIndex]}
                  index={activeIndex}
                  openDialog={this.openDialog}
                  onValueChange={this.handleValueChange}
                  onVisibility={this.handleVisibility}
                  onUserData={this.handleUserData}
                  onPage={this.onPage}
                  totalRecords={totalRecords}
                />
              </TabPanel>
            </TabView>
          </div>

          <ReleaseObjectsDialog
            onHide={this.onHide}
            currentNode={currentNode}
            confirmDialog={this.confirmDialog}
            rejectDialog={this.rejectDialog}
            currentDialogType={currentDialogType}
          />
        </div>
      </div>
    );
  }
}
